import { format } from "date-fns";

export const fmtParam = (d) => (d ? format(d, "yyyy-MM-dd") : "");
export const fmtLabel = (d) => (d ? format(d, "MMM d, yyyy") : "");

/** Bucket items into the last `days` calendar days (UTC) by `timestamp` field. */
export function bucketByDay(items, days = 7) {
  const buckets = Array(days).fill(0);
  const todayStart = new Date();
  todayStart.setHours(0, 0, 0, 0);
  const todayMs = todayStart.getTime();
  items.forEach((r) => {
    const t = new Date(r.timestamp).getTime();
    const dayDelta = Math.floor((todayMs - new Date(t).setHours(0, 0, 0, 0)) / 86400000);
    if (dayDelta >= 0 && dayDelta < days) buckets[days - 1 - dayDelta] += 1;
  });
  return buckets;
}
